/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {forgetEntity} from '../api'

export const useMutationForgetEntity = createReactQueryMutationHook('forgetEntity', forgetEntity)
